import { FunctionComponent, ReactNode } from "react";
import styles from "./Steppers.module.css";
import SteppersMarkerAtom from "../../atoms/steppers/marker";
import SteppersTrackAtom from "../../atoms/steppers/track";
import SteppersLabelContentAtom from "../../atoms/steppers/label-content";

export type SteppersType = {
  className?: string;
  direction?: "horizontal" | "vertical";
  steps: {
    label?: string;
    description?: string;
    indicator?: "default" | "fail" | "warning";
    type?: "inactive" | "inprogress" | "complete";
    icon?: ReactNode;
  }[];
  marker?: "icon" | "number" | "dot";
  size?: "sm" | "md" | "lg";
  onClick?: (step: SteppersType["steps"][number]) => void;
};

export const Steppers: FunctionComponent<SteppersType> = ({
  className = "",
  direction = "horizontal",
  steps = [],
  marker = "dot",
  size = "sm",
  onClick,
}) => {
  const handleClick = (step: SteppersType["steps"][number]) => {
    if (onClick) {
      onClick(step);
    }
  };
  return (
    <div
      className={[styles.root, className, "quill-ui-next-component"].join(" ")}
      data-direction={direction}
      data-size={size}
    >
      {steps.map((step, index) => {
        const isLastStep = index === steps.length - 1;
        const isFirstStep = index === 0;
        const nextStep = steps[index + 1];
        const nextStepType = nextStep?.type;

        let trackType = step.type === "complete" ? "inprogress" : step.type;
        let track1 = trackType;
        let track2 = trackType;

        if (isFirstStep) {
          track1 = undefined;
        }

        if (isLastStep) {
          track2 = undefined;
        }

        return (
          <div
            className={styles.stepper_container}
            key={`stepper-${index}`}
            onClick={() => handleClick(step)}
          >
            <div className={styles.header}>
              <SteppersTrackAtom
                className={styles.track}
                type={track1 === undefined ? "hidden" : track1}
                direction={direction}
              />
              <SteppersMarkerAtom
                marker={marker}
                indicator={step.indicator}
                size={size}
                text={index + 1}
                type={step.type}
                icon={step?.icon}
              />
              <SteppersTrackAtom
                type={
                  track2 === undefined
                    ? "hidden"
                    : nextStepType === "inactive"
                    ? "inactive"
                    : track2
                }
                direction={direction}
              />
            </div>
            <SteppersLabelContentAtom
              label={step?.label}
              description={step?.description}
              direction={direction}
              type={step.type === "inactive" ? "incomplete" : step.type}
            />
          </div>
        );
      })}
    </div>
  );
};

Steppers.displayName = "Steppers";

export default Steppers;
